export enum ProjectExitModalType {
  AyetDelayed = 'AyetDelayed',
  BadQuality = 'BadQuality',
  Dashboard = 'Dashboard',
  NotQualified = 'NotQualified',
  OverQuota = 'OverQuota',
  OverQuotaNoReview = 'OverQuotaNoReview',
  ProjectCompleted = 'ProjectCompleted',
  TechnicalIssue = 'TechnicalIssue',
}
